export class AlertModel {
  InsertAlertMainInput: InsertAlertMainInput = new InsertAlertMainInput();
  InsertAlertRSATInput: InsertAlertRSATInput = new InsertAlertRSATInput();
  InsertAlertSOInput: InsertAlertSOInput = new InsertAlertSOInput();
  InsertAlertDischargeStatementInput: InsertAlertDischargeStatementInput = new InsertAlertDischargeStatementInput();
  InsertAlertChecksInput: InsertAlertChecksInput = new InsertAlertChecksInput();
  InsertAlertCSECInput: InsertAlertCSECInput = new InsertAlertCSECInput();
  InsertAlertPCInput: InsertAlertPCInput = new InsertAlertPCInput();
  InsertAlertCAInput: InsertAlertCAInput = new InsertAlertCAInput();
}

class InsertAlertMainInput {
  JuvenileID: number = null;
  JuvID: string = null;
  AlertId: string = null;
  AlertBeginDate: any = null;
  AlertEndDate: any = null;
  AlertContactID: number = null;
  AlertComments = '';
  UserId: string = null;
}

class InsertAlertRSATInput {
  RSATRequire: number = null;
  RSATTreatmentComments: string = null;
  RSATCounselor: number = null;
  RSATTreatment: number = null;
  RSATTreatmentBeginDate: any = null;
  RSATTreatmentEndDate: any = null;
  RSATAwaitingBeginDate: any = null;
  RSATAwaitingEndDate: any = null;
  RSATReasonNotCompleted: string = null;
  RSATDateOfReason: any = null;
}

class InsertAlertSOInput {
  SORequire: number = null;
  SOTreatmentComments: string = null;
  SOCounselor: number = null;
  SOLevel: number = null;
  SOTreatment: number = null;
  SOTreatmentBeginDate: any = null;
  SOTreatmentEndDate: any = null;
  SOAwaitingBeginDate: any = null;
  SOAwaitingEndDate: any = null;
  SOReasonNotCompleted: string = null;
  SOReasonDate: any = null;
  SORPPComments: string = null;
  SORPPDate: any = null;
}

class InsertAlertDischargeStatementInput {
  DischargeStatement: string = null;
}

class InsertAlertChecksInput {
  chkSuicidePrevention = 0;
  chkBehaviorProblems = 0;
  chkVictimizationRisk = 0;
  chkReferral = 0;
}

class InsertAlertCSECInput {
  CSECStatus: string = null;
  CSECBeginDate: any = null;
  CSECEndDate: any = null;
}

class InsertAlertPCInput {
  PCSegregated: string = null;
  PCStartDate: any = null;
  PCEndDate: any = null;
}

class InsertAlertCAInput {
  ConfinementType: number = null;
  CAStartDate: any = null;
  CAEndDate: any = null;
}
